import React from "react";
import { Button, Grid, GridItem, Input, Select } from "@chakra-ui/react";
import { BsArrowCounterclockwise } from "react-icons/bs";

const RiskReviewRequestFilters = ({ filters, onChange, onReset }) => {
  const update = (key, value) => onChange({ ...filters, [key]: value, page: 1 });

  return (
    <Grid templateColumns={{ base: "1fr", lg: "minmax(260px, 2fr) 160px 150px minmax(180px, 1fr) auto" }} gap={3}>
      <GridItem>
        <Input
          placeholder="Search by request or project"
          value={filters.search || ""}
          onChange={(event) => update("search", event.target.value)}
          focusBorderColor="blue.400"
        />
      </GridItem>
      <GridItem>
        <Select value={filters.status || ""} onChange={(event) => update("status", event.target.value)}>
          <option value="">All statuses</option>
          <option value="DRAFT">Draft</option>
          <option value="PENDING_APPROVAL">Pending Approval</option>
          <option value="APPROVED">Approved</option>
          <option value="REJECTED">Rejected</option>
          <option value="WITHDRAWN">Withdrawn</option>
        </Select>
      </GridItem>
      <GridItem>
        <Select value={filters.requestType || ""} onChange={(event) => update("requestType", event.target.value)}>
          <option value="">All types</option>
          <option value="INTERNAL">Internal</option>
          <option value="THIRD_PARTY">Third Party</option>
        </Select>
      </GridItem>
      <GridItem>
        <Input
          placeholder="Business Unit"
          value={filters.businessUnit || ""}
          onChange={(event) => update("businessUnit", event.target.value)}
        />
      </GridItem>
      <GridItem>
        <Button variant="outline" leftIcon={<BsArrowCounterclockwise />} onClick={onReset}>
          Reset
        </Button>
      </GridItem>
    </Grid>
  );
};

export default RiskReviewRequestFilters;
